import { DigitsInfo } from '../models/digits-info';
      
      export class DigitsInfoHelper {
          static convertToString(digitsInfo: DigitsInfo) {
              return `${digitsInfo.minIntegerDigits}.${digitsInfo.minFractionDigits}-${digitsInfo.maxFractionDigits}`;
          }
      
          static parseFromString(digitsInfo: string): DigitsInfo {
              const partsByDot = digitsInfo.split('.');
      
              const minIntegerDigits = parseInt(partsByDot[0]);
      
              const partsByDash = partsByDot[1].split('-');
      
              const minFractionDigits = parseInt(partsByDash[0]);;
              const maxFractionDigits = parseInt(partsByDash[1]);;
      
              return {
                  minIntegerDigits: minIntegerDigits,
                  minFractionDigits: minFractionDigits,
                  maxFractionDigits: maxFractionDigits
              }
          }
      }